import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-notification-service-component',
  imports: [],
  templateUrl: './notification-service-component.html',
  styleUrl: './notification-service-component.css'
})
export class NotificationServiceComponent {
  constructor( @Inject( MAT_SNACK_BAR_DATA ) public data: string[] ) { }
}
